import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["phone", "code", "button", "label", "status"];
  static values = { purpose: String };

  connect() {
    this.coolingDown = false;
    this.updateButton();
  }

  updateButton() {
    this.buttonTarget.disabled =
      this.coolingDown || !/^1[3-9]\d{9}$/.test(this.phoneTarget.value.trim());
  }

  async send() {
    const phone = this.phoneTarget.value.trim();
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      this.statusTarget.textContent = "请输入正确的手机号码";
      return;
    }
    this.coolingDown = true;
    this.buttonTarget.disabled = true;
    try {
      const response = await fetch("/users/phone_verifications", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
            .content,
        },
        body: JSON.stringify({ phone, purpose: this.purposeValue }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || "验证码发送失败");
      this.statusTarget.textContent = payload.message;
      let remaining = 60;
      const timer = window.setInterval(() => {
        remaining -= 1;
        this.labelTarget.textContent = `${remaining}秒后重试`;
        if (remaining <= 0) {
          window.clearInterval(timer);
          this.coolingDown = false;
          this.labelTarget.textContent = "获取验证码";
          this.updateButton();
        }
      }, 1000);
    } catch (error) {
      this.statusTarget.textContent = error.message;
      this.coolingDown = false;
      this.updateButton();
    }
  }
}
